import React, { Component } from 'react';
import {InputText} from 'primereact/components/inputtext/InputText';
import { ENGRAVING_TIMEOUT } from '../constants';
import {filter} from '../reducers/utils'


class AiInputText extends Component {
  constructor(props){
    super(props);
  //  this.inputText = React.createRef();
    let len= 0
    let text =''
     
    if (this.props.value !== undefined)  {
      text =filter(this.props.value,this.props.filter,this.props.maxLength)
      //text =this.props.value
      len = text.length
    }
    //console.log('TEXT CONSTR',this.props.attr,this.props.value) //,this.state.text)
 
    this.state = { len: len, text:text };
    this.onChange = this.onChange.bind(this);  
    this.props.onLoadingDone()
   
}
  componentDidUpdate(){
    
    var newText =filter(this.props.value,this.props.filter,this.props.maxLength)
    //console.log('newText',newText,this.props.loading)
  if (newText !== this.state.text   && this.props.loading ==='new'  ) {
    this.setState({text : newText })
    this.setState({len : newText.length})
    this.props.onLoadingDone()
  }
    //console.log('TEXT DIDupdate',this.props.attr,this.props.value,this.state.text,this.props.loading)
   
   
    if (this.props.value !== this.state.text)
    {
      setTimeout(() => {
        this.props.onChange(this.state.text)
      }, ENGRAVING_TIMEOUT)
    }
      
}

onChange(e) { 
   //console.log('onchange(e)',this.state.text,this.props.loading,this.props.filter) 
   const newText = filter(e.target.value,this.props.filter); 
   if (newText !== this.state.text ) {
      this.setState({text : newText});  
      this.setState({len : newText.length});
  }
   //console.log('onchange(e) end',this.state) 
  
}  

  render() {
    //console.log('RENDER TextInput',this.props.attr,this.props.value,'loading-',this.props.loading)
   //onChange={(e) => {this.setState ({len:this.getLength(e.target.value)});this.props.onChange(e.target.value)}}/>
    //this.setState ({len:this.props.value.length,text:filter(this.props.value)})

  //  console.log('renderInput',this.state)
   return (
     <div className={'ai-inputtext-box '+this.props.show}  >
    <label className='ai-inputtext-label'>{this.props.name}</label>
    <InputText 
    key={this.props.key}
    // ref="inputText"
    className='ai-inputtext'
    type="text" 
   // defaultValue={this.props.value}
    onFocus={()=>this.props.onFocus(this.props.cur_ga_event)}
    maxLength={this.props.maxLength} 
    
    value={this.state.text}
    onChange={this.onChange}
    onBlur={this.props.onBlur}  
  
  

    />
    <label className="ai-inputtext-count">{this.state.len} / {this.props.maxLength}</label>
    
    
    </div>
);
  }
}
//export default connect()(AiInput);
export default AiInputText;


// WEBPACK FOOTER //
// ./src/layout/AiInputText.js